<c-card class="broadcast-card shadow-sm border-0" *transloco="let t">
  <c-card-body *ngIf="broadcast">
    <div class="broadcast-page-header">
      <div class="broadcast-page-header__title">
        <span class="broadcast-page-header__icon"
              [ngClass]="{ 'broadcast-page-header__icon--critical': broadcast.priority === 'critical' }">
          <i class="fa-solid" [ngClass]="broadcast.priority === 'critical' ? 'fa-triangle-exclamation' : 'fa-bullhorn'"></i>
        </span>
        <div>
          <h1 class="broadcast-page-header__heading">
            {{ broadcast.title }}
            <span class="badge broadcast-badge ms-2" [ngClass]="statusBadgeClass(broadcast.status)">
              <i class="fa-solid fa-circle-check me-1" *ngIf="broadcast.status === 'sent'"></i>{{ broadcast.status }}
            </span>
          </h1>
          <p class="broadcast-page-header__subtitle">
            <i class="fa-solid fa-circle-check text-success me-1"></i>
            {{ t('Sending Completed') }} — {{ broadcast.recipient_count }} {{ t('notifications') }}.
          </p>
        </div>
      </div>
      <div class="broadcast-page-header__actions">
        <button cButton class="btn btn-ghost" (click)="back()">
          <i class="fa-solid fa-arrow-left me-1"></i> {{ t('Back') }}
        </button>
        <button cButton class="btn btn-ghost" title="{{ t('Refresh') }}" (click)="loadBroadcast(); loadRecipients()">
          <i class="fa-solid fa-rotate-right me-1"></i> {{ t('Refresh') }}
        </button>
        <button cButton class="btn btn-create" *ngIf="broadcast.status === 'sent'" (click)="exportBroadcast()">
          <i class="fa-solid fa-download me-1"></i> {{ t('Export') }}
        </button>
      </div>
    </div>

    <c-row class="g-3 mb-4">
      <c-col md="3" sm="6">
        <div class="stat-tile stat-tile--sent">
          <span class="stat-tile__icon"><i class="fa-solid fa-paper-plane"></i></span>
          <div class="stat-tile__value">{{ broadcast.recipient_count }}</div>
          <div class="stat-tile__label">{{ t('Sent') }}</div>
        </div>
      </c-col>
      <c-col md="3" sm="6">
        <div class="stat-tile stat-tile--delivered">
          <span class="stat-tile__icon"><i class="fa-solid fa-truck-fast"></i></span>
          <div class="stat-tile__value">{{ broadcast.delivered_count }} <small>({{ broadcast.delivered_pct }}%)</small></div>
          <div class="stat-tile__label">{{ t('Delivered') }}</div>
          <c-progress class="stat-tile__progress" thin>
            <c-progress-bar [value]="broadcast.delivered_pct || 0" color="primary-gradient"></c-progress-bar>
          </c-progress>
        </div>
      </c-col>
      <c-col md="3" sm="6">
        <div class="stat-tile stat-tile--read">
          <span class="stat-tile__icon"><i class="fa-solid fa-envelope-open"></i></span>
          <div class="stat-tile__value">{{ broadcast.read_count }} <small>({{ broadcast.read_pct }}%)</small></div>
          <div class="stat-tile__label">{{ t('Read') }}</div>
          <c-progress class="stat-tile__progress" thin>
            <c-progress-bar [value]="broadcast.read_pct || 0" color="info-gradient"></c-progress-bar>
          </c-progress>
        </div>
      </c-col>
      <c-col md="3" sm="6">
        <div class="stat-tile stat-tile--ack">
          <span class="stat-tile__icon"><i class="fa-solid fa-circle-check"></i></span>
          <div class="stat-tile__value">{{ broadcast.ack_count }} <small>({{ broadcast.ack_pct }}%)</small></div>
          <div class="stat-tile__label">{{ t('Acknowledged') }}</div>
          <c-progress class="stat-tile__progress" thin>
            <c-progress-bar [value]="broadcast.ack_pct || 0" color="success-gradient"></c-progress-bar>
          </c-progress>
        </div>
      </c-col>
    </c-row>

    <c-row class="g-4">
      <c-col md="8">
        <h5 class="broadcast-section-title"><i class="fa-solid fa-users me-2"></i>{{ t('Recipients') }}</h5>
        <form cForm class="broadcast-filter-bar" [formGroup]="formGroup" (ngSubmit)="updateFilter()">
          <c-row class="g-2 align-items-end">
            <c-col class="col-12 col-lg-5">
              <label cLabel class="broadcast-filter-bar__label">{{ t('Person') }}</label>
              <c-input-group>
                <span cInputGroupText><svg cIcon class="me-2" name="cil-search"></svg></span>
                <input cFormControl type="text" formControlName="search" placeholder="{{ t('Name...') }}" />
              </c-input-group>
            </c-col>
            <c-col class="col-8 col-lg-5">
              <label cLabel class="broadcast-filter-bar__label">{{ t('Status') }}</label>
              <select cSelect formControlName="state">
                <option value="">{{ t('All') }}</option>
                <option value="pending">{{ t('Pending') }}</option>
                <option value="sent">{{ t('Sent') }}</option>
                <option value="delivered">{{ t('Delivered') }}</option>
                <option value="read">{{ t('Read') }}</option>
                <option value="acknowledged">{{ t('Acknowledged') }}</option>
              </select>
            </c-col>
            <c-col class="col-4 col-lg-2">
              <button cButton class="btn btn-light" type="submit">
                <i class="fa-solid fa-magnifying-glass"></i>
                <span class="d-none d-lg-inline ms-1">{{ t('Search') }}</span>
              </button>
            </c-col>
          </c-row>
        </form>

        <div class="broadcast-table-wrap">
          <table [hover]="true" [responsive]="true" align="middle" cTable class="broadcast-table mb-0">
            <thead>
              <tr>
                <th>{{ t('Name') }}</th>
                <th>{{ t('Sent To') }}</th>
                <th>{{ t('Current State') }}</th>
                <th class="text-nowrap">{{ t('Read') }}</th>
                <th class="text-nowrap">{{ t('Acknowledged') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let recipient of recipients">
                <td>
                  <span class="broadcast-sender">
                    <span class="broadcast-avatar">{{ initials(recipient.worker?.name) }}</span>
                    <span class="broadcast-sender__name">{{ recipient.worker?.name || recipient.worker_id }}</span>
                  </span>
                </td>
                <td class="text-muted">{{ recipient.sent_to }}</td>
                <td>
                  <span class="badge broadcast-badge" [ngClass]="stateBadgeClass(recipient.current_state)">
                    {{ recipient.current_state }}
                  </span>
                </td>
                <td class="text-nowrap text-muted">{{ recipient.read_at_local || '—' }}</td>
                <td class="text-nowrap text-muted">{{ recipient.acknowledged_at_local || '—' }}</td>
              </tr>
              <tr *ngIf="recipients.length === 0">
                <td colspan="5" class="text-center text-muted py-4">{{ t('No recipients found.') }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="broadcast-pagination" *ngIf="pagination.totalPages > 1">
          <c-input-group class="broadcast-pagination__group">
            <span cInputGroupText><i class="fa-solid fa-file-lines"></i></span>
            <select cSelect [(ngModel)]="pagination.page" [ngModelOptions]="{standalone: true}" (change)="changePage()">
              <option *ngFor="let p of pagination.pageArray" [value]="p">{{ t('Page') }} {{ p }}</option>
            </select>
          </c-input-group>
        </div>
      </c-col>

      <c-col md="4">
        <h5 class="broadcast-section-title"><i class="fa-solid fa-comment-dots me-2"></i>{{ t('Message') }}</h5>
        <div class="message-panel">
          <div class="message-panel__row">
            <span class="message-panel__label">{{ t('Created') }}</span>
            <span class="message-panel__value">{{ broadcast.created_local || broadcast.created }}</span>
          </div>
          <div class="message-panel__row">
            <span class="message-panel__label">{{ t('Created By') }}</span>
            <span class="broadcast-sender">
              <span class="broadcast-avatar">{{ initials(broadcast.sender?.name) }}</span>
              <span class="broadcast-sender__name">{{ broadcast.sender?.name || broadcast.user_id }}</span>
            </span>
          </div>
          <div class="message-panel__row">
            <span class="message-panel__label">{{ t('Subject') }}</span>
            <span class="message-panel__value fw-semibold">{{ broadcast.title }}</span>
          </div>
          <div class="message-panel__row">
            <span class="message-panel__label">{{ t('Summary') }}</span>
            <span class="message-panel__value">{{ broadcast.summary }}</span>
          </div>
          <div class="message-panel__row">
            <span class="message-panel__label">{{ t('Details') }}</span>
            <span class="message-panel__value message-panel__body">{{ broadcast.body }}</span>
          </div>
          <div class="message-panel__row">
            <span class="message-panel__label">{{ t('Priority') }}</span>
            <span>
              <span class="badge broadcast-badge" [ngClass]="broadcast.priority === 'critical' ? 'bg-danger' : 'bg-primary'">
                {{ broadcast.priority }}
              </span>
            </span>
          </div>
          <div class="message-panel__row" *ngIf="broadcast.send_all">
            <span class="message-panel__label">{{ t('Recipients') }}</span>
            <span class="message-panel__value">{{ t('All Users') }}</span>
          </div>
          <div class="message-panel__row" *ngIf="!broadcast.send_all && broadcast.group_ids?.length">
            <span class="message-panel__label">{{ t('Groups') }}</span>
            <span class="message-panel__value">{{ broadcast.group_ids.join(', ') }}</span>
          </div>
          <div class="message-panel__row" *ngIf="!broadcast.send_all && broadcast.worker_ids?.length">
            <span class="message-panel__label">{{ t('People') }}</span>
            <span class="message-panel__value">{{ broadcast.worker_ids.join(', ') }}</span>
          </div>
        </div>
      </c-col>
    </c-row>
  </c-card-body>
</c-card>
